import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const ViewPurchaseBill = () => {
  const [records, setRecords] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const formatDateTime = (date) => {
    const pad = (num) => num.toString().padStart(2, "0");
    const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    return `${istDate.getFullYear()}-${pad(istDate.getMonth() + 1)}-${pad(istDate.getDate())} ${pad(istDate.getHours())}:${pad(istDate.getMinutes())}:${pad(istDate.getSeconds())}`;
  };

  const fetchRecords = async () => {
    try {
      const response = await axiosInstance.get("/api/upload-purchase");
      setRecords(response.data);
    } catch (error) {
      console.error("Error fetching purchase records:", error);
    }
  };

  const handleConfirmReceipt = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await axiosInstance.patch(`/api/upload-purchase/${id}/confirm-receipt`, {
        ReceivedBy: user?.Name || "Receiver"
      });
      alert("Marked as received successfully");
      fetchRecords();
    } catch (err) {
      alert("Failed to confirm receipt");
    }
  };

  const API_BASE_URL = axiosInstance.defaults.baseURLPath;
  const handleViewImage = (imagePath) => {
    setSelectedImage(`${API_BASE_URL}/uploads/${imagePath}`);
    setShowImageModal(true);
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const columns = [
    { name: "Bill Number", selector: (row) => row.BillNumber, sortable: true },
    { name: "Quantity", selector: (row) => row.Quantity, sortable: true },
     // NEW FIELDS
    { name: "Qty in KG", selector: (row) => row.Quantity_in_KG || "N/A", sortable: true },
    { name: "PO Number", selector: (row) => row.PO_Number || "N/A", sortable: true },
    { name: "L/U Amount", selector: (row) => row.Loading_Unloading_amount || "N/A", sortable: true },
    {
      name: "Product",
      width: "200px",
      selector: (row) => (
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={row.Product}
        >
          {row.Product || "N/A"}
        </span>
      ),
      sortable: true,
    },
    { name: "Transporter",width:"150px", selector: (row) => (
        <span data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={row.Transporter_Name}>

          {row.Transporter_Name || "N/A"}
          </span>
        
    ), sortable: true },
    {
      name: "Status",
      selector: (row) => (
        <span
          style={{
            padding: "4px 10px",
            borderRadius: "6px",
            fontWeight: "bold",
            color:
              row.Status === "Received" ? "#155724" :
              row.Status === "Pending" ? "#856404" : "#721c24",
            backgroundColor:
              row.Status === "Received" ? "#d4edda" :
              row.Status === "Pending" ? "#fff3cd" : "#f8d7da"
          }}
        >
          {row.Status}
        </span>
      ),
      sortable: true
    },
    {
      name: "Remarks",width:"230px",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Remarks}>

        {row.Remarks || "N/A"}
        </span>
      ),
    //   row.Remark,
      sortable: false,
    },
    {
      name: "Image",
      cell: (row) =>
        row.BillImagePath ? (
          <button className="btn btn-sm btn-outline-info" onClick={() => handleViewImage(row.BillImagePath)}>
            View
          </button>
        ) : (
          <span className="text-muted">No Image</span>
        )
    },
    {
      name: "Actions",width:"150px",
      cell: (row) =>
        row.Status === "Received" ? (
          <button className="btn btn-sm btn-success" disabled style={{ cursor: "not-allowed", opacity: 0.6 }}>
            Received
          </button>
        ) : (
          <button className="btn btn-sm btn-primary" onClick={() => handleConfirmReceipt(row.ID)} 
          style={{fontSize:"11px"}}>
            Mark as Received
          </button>
        )
    },
    { name: "Created At",width:"150px", selector: (row) => formatDateTime(row.CreatedAt), sortable: true },
    { name: "Uploaded At", selector: (row) => row.ImageUploadedAt || "N/A", sortable: true },
 
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <h4 className="mb-4">Verify Purchase Bills</h4>
          <DataTable columns={columns} data={records} pagination />
        </main>
      </div>

      {showImageModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show" style={{ display: "block" }}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Uploaded Bill Image</h5>
                  <button type="button" className="btn-close" onClick={() => setShowImageModal(false)}></button>
                </div>
                <div className="modal-body text-center">
                  <img
                    src={selectedImage}
                    alt="Uploaded Bill"
                    style={{ maxWidth: "100%", maxHeight: "500px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewPurchaseBill;
